import { useState } from 'react';
import { useSelector } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import { useEstadisticas } from './hooks/useEstadisticas';

import { CheckboxInput, ConsultorioSelector, DateInput, Error, Forbidden, Loader, ReactMultiValueSelectInput, ReactSelectSingleKeyInput, TextInputPreview } from '../../components';

import styles from './Estadisticas.module.css';
import { colors } from '../../types/types';

export const Estadisticas = () => {

    const { permisos } = useSelector(state => state.auth);

    const [categorias, setCategorias] = useState([{_id: '1', nombre: 'Consultas'}]);
    const [categoriaConsultas, setCategoriaConsultas] = useState(true);
    const [categoriaPruebasAlergia, setCategoriaPruebasAlergia] = useState(false);
    const [categoriaTipoInmunoterapias, setCategoriaTipoInmunoterapias] = useState(false);
    const [categoriaEstatusInmunoterapias, setCategoriaEstatusInmunoterapias] = useState(false);
    const [categoriaMediosContacto, setCategoriaMediosContacto] = useState(false);
    const [consultasTotales, setConsultasTotales] = useState(true);
    const [consultasPrimeraVez, setConsultasPrimeraVez] = useState(true);
    const [consultasSubsecuentes, setConsultasSubsecuentes] = useState(true);
    const [pruebasDeAlergia, setPruebasDeAlergia] = useState(true);
    const [pruebasDeAlergiaPositivas, setPruebasDeAlergiaPositivas] = useState(true);
    const [pruebasDeAlergiaNegativas, setPruebasDeAlergiaNegativas] = useState(true);
    const [inmunoterapias, setInmunotarapias] = useState(true);
    const [inmunoterapiaSubcutanea, setInmunotarapiaSubcutanea] = useState(true);
    const [inmunoterapiaSublingual, setInmunotarapiaSublingual] = useState(true);
    const [alxoid, setAlxoid] = useState(true);
    const [oraltek, setOraltek] = useState(true);
    const [inmunoterapiaDeInicio, setInmunoterapiaDeInicio] = useState(true);
    const [inmunoterapiasTerminadas, setInmunoterapiasTerminadas] = useState(true);
    const [inmunoterapiasInconclusas, setInmunoterapiasInconclusas] = useState(true);
    const [medioContactoInstagram, setMedioContactoInstagram] = useState(true);
    const [medioContactoFacebook, setMedioContactoFacebook] = useState(true);
    const [medioContactoTiktok, setMedioContactoTiktok] = useState(true);
    const [medioContactoPaginaWeb, setMedioContactoPaginaWeb] = useState(true);
    const [medioContactoReferenciaOtroDoctor, setMedioContactoReferenciaOtroDoctor] = useState(true);
    const [medioContactoReferenciaFamiliar, setMedioContactoReferenciaFamiliar] = useState(true);
    const [medioContactoReferenciaAmistad, setMedioContactoReferenciaAmistad] = useState(true);
    const [medioContactoCentroMedicoHospital, setMedioContactoCentroMedicoHospital] = useState(true);
    const [medioContactoOtro, setMedioContactoOtro] = useState(true);
    const [medioContactoNoEspecificado, setMedioContactoNoEspecificado] = useState(true);
    const [periodo, setPeriodo] = useState('5');
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');

    const { estadisticasQuery: { isLoading, isError, isFetching, data } } = useEstadisticas({ periodo, desde, hasta });

    const dataAux = [
        {
            name: '',
            'Consultas totales': null,
            'Consultas primera vez': null,
            'Consultas subsecuentes': null,
            'Pruebas de alergia': null,
            'Pruebas de alergia positivas': null,
            'Pruebas de alergia negativas': null,
            'Inmunoterapias': null,
            'Inmunoterapia subcutánea': null,
            'Inmunoterapia sublingual': null,
            'Alxoid': null,
            'Oraltek': null,
            'Inmunoterapia de inicio': null,
            'Inmunoterapias terminadas': null,
            'Inmunoterapias inconclusas': null,
            'Instagram': null,
            'Facebook': null,
            'Tiktok': null,
            'Pagina web': null,
            'Referencia otro doctor': null,
            'Referencia familiar': null,
            'Referencia amistad': null,
            'Centro médico/hospital': null,
            'Otro': null,
            'No especificado': null
        },
        ...(typeof data.data !== 'undefined') ? data.data.grafica : [],
        {
            name: '',
            'Consultas totales': null,
            'Consultas primera vez': null,
            'Consultas subsecuentes': null,
            'Pruebas de alergia': null,
            'Pruebas de alergia positivas': null,
            'Pruebas de alergia negativas': null,
            'Inmunoterapias': null,
            'Inmunoterapia subcutánea': null,
            'Inmunoterapia sublingual': null,
            'Alxoid': null,
            'Oraltek': null,
            'Inmunoterapia de inicio': null,
            'Inmunoterapias terminadas': null,
            'Inmunoterapias inconclusas': null,
            'Instagram': null,
            'Facebook': null,
            'Tiktok': null,
            'Pagina web': null,
            'Referencia otro doctor': null,
            'Referencia familiar': null,
            'Referencia amistad': null,
            'Centro médico/hospital': null,
            'Otro': null,
            'No especificado': null
        },
    ];

    const handleOnCategoriasChange = (e) => {
        setCategorias(e.target.value);
        let categoriaConsultasAux = false;
        let categoriaPruebasAlergiaAux = false;
        let categoriaTipoInmunoterapiasAux = false;
        let categoriaEstatusInmunoterapiasAux = false;
        let categoriaMediosContactoAux = false;
        e.target.value.forEach(categoria => {
            switch (categoria._id) {
                case '1':
                    categoriaConsultasAux = true;
                    break;
                case '2':
                    categoriaPruebasAlergiaAux = true;
                    break;
                case '3':
                    categoriaTipoInmunoterapiasAux = true;
                    break;
                case '4':
                    categoriaEstatusInmunoterapiasAux = true;
                    break;
                case '5':
                    categoriaMediosContactoAux = true;
                    break;
            
                default:
                    break;
            }
        });
        setCategoriaConsultas(categoriaConsultasAux);
        setCategoriaPruebasAlergia(categoriaPruebasAlergiaAux);
        setCategoriaTipoInmunoterapias(categoriaTipoInmunoterapiasAux);
        setCategoriaEstatusInmunoterapias(categoriaEstatusInmunoterapiasAux);
        setCategoriaMediosContacto(categoriaMediosContactoAux);
    }

    const handleOnPeriodoChange = (e) => {
        setPeriodo(e.target.value);
    }

    const handleOnDesdeChange = (e) => {
        setDesde(e.target.value);
    }

    const handleOnHastaChange = (e) => {
        setHasta(e.target.value);
    }

    return (permisos.estadisticas) ? (
        <>
            <div className="row">
                <div className="col">
                    <div className={styles.panel + " " + styles.panelNoHeader}>
                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className={styles.header}>Estadisticas</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <TextInputPreview
                                    label='Consultorio'
                                    name='consultorio'
                                    value={<ConsultorioSelector />}
                                />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <TextInputPreview
                                    label='Categorias'
                                    name='categorias'
                                    value={<ReactMultiValueSelectInput
                                        formsStatus={ true }
                                        name="categorias"
                                        onChange={ handleOnCategoriasChange }
                                        placeholder='Selecciona categorias...'
                                        setFormFieldValidation={ () => {} }
                                        value={categorias}
                                        values={[
                                            {_id: '1', nombre: 'Consultas'},
                                            {_id: '2', nombre: 'Pruebas de alergia'},
                                            {_id: '3', nombre: 'Tipo de inmunoterapia'},
                                            {_id: '4', nombre: 'Estatus de inmunoterapia'},
                                            {_id: '5', nombre: 'Medios de contacto'}
                                        ]}
                                    />}
                                />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                <ReactSelectSingleKeyInput
                                    formFieldStatus="checked"
                                    label="Periodo"
                                    name="periodo"
                                    onChange={ handleOnPeriodoChange }
                                    required={false}
                                    requiredIndicator={false}
                                    setFormFieldValidation={ () => {} }
                                    value={periodo}
                                    values={[{ value: '0', label: 'Personalizado' }, { value: '1', label: 'Hoy' }, { value: '2', label: 'Esta semana (L-Hoy)' }, { value: '3', label: 'Últimos 7 días' }, { value: '4', label: 'Semana pasada (L-D)' }, { value: '5', label: 'Últimos 14 días' }, { value: '6', label: 'Este mes' }, { value: '7', label: 'Últimos 30 días' }, { value: '8', label: 'Mes pasado' }, { value: '9', label: 'Desde siempre' }]}
                                />
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-3">
                                {(periodo === '0') &&
                                <div className="row">
                                    <div className="col">
                                        <DateInput
                                            formFieldStatus="checked"
                                            label="Desde"
                                            name="desde"
                                            onChange={ handleOnDesdeChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ () => {} }
                                            value={ desde }
                                        />
                                    </div>
                                    <div className="col">
                                        <DateInput
                                            formFieldStatus="checked"
                                            label="Hasta"
                                            name="hasta"
                                            onChange={ handleOnHastaChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ () => {} }
                                            value={ hasta }
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            {(categoriaConsultas) && <>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_1 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='consultasTotales'
                                            onChange={() => setConsultasTotales(!consultasTotales)}
                                            checked={consultasTotales}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Consultas</div>
                                        <div>totales</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.consultasContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_2 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='consultasPrimeraVez'
                                            onChange={() => setConsultasPrimeraVez(!consultasPrimeraVez)}
                                            checked={consultasPrimeraVez}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Consultas</div>
                                        <div>primera vez</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.consultasPrimeraVezContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_3 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='consultasSubsecuentes'
                                            onChange={() => setConsultasSubsecuentes(!consultasSubsecuentes)}
                                            checked={consultasSubsecuentes}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Consultas</div>
                                        <div>subsecuentes</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.consultasSubsecuentesContador }</div>
                                </div>
                            </div>
                            </>}
                            {(categoriaPruebasAlergia) && <>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_4 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='pruebasDeAlergia'
                                            onChange={() => setPruebasDeAlergia(!pruebasDeAlergia)}
                                            checked={pruebasDeAlergia}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Pruebas de</div>
                                        <div>alergia</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.pruebasDeAlergiaContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_5 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='pruebasDeAlergiaPositivas'
                                            onChange={() => setPruebasDeAlergiaPositivas(!pruebasDeAlergiaPositivas)}
                                            checked={pruebasDeAlergiaPositivas}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Pruebas de</div>
                                        <div>alergia positivas</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.pruebasDeAlergiaPositivasContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_6 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='pruebasDeAlergiaNegativas'
                                            onChange={() => setPruebasDeAlergiaNegativas(!pruebasDeAlergiaNegativas)}
                                            checked={pruebasDeAlergiaNegativas}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Pruebas de</div>
                                        <div>alergia negativas</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.pruebasDeAlergiaNegativasContador }</div>
                                </div>
                            </div>
                            </>}
                            {(categoriaTipoInmunoterapias) && <>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_7 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='inmunoterapias'
                                            onChange={() => setInmunotarapias(!inmunoterapias)}
                                            checked={inmunoterapias}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Inmunoterapias</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.inmunoterapiasContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_8 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='inmunoterapiaSubcutanea'
                                            onChange={() => setInmunotarapiaSubcutanea(!inmunoterapiaSubcutanea)}
                                            checked={inmunoterapiaSubcutanea}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Inmunoterapia</div>
                                        <div>subcutánea</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.inmunoterapiaSubcutaneaContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_9 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='inmunoterapiaSublingual'
                                            onChange={() => setInmunotarapiaSublingual(!inmunoterapiaSublingual)}
                                            checked={inmunoterapiaSublingual}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Inmunoterapia</div>
                                        <div>sublingual</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.inmunoterapiaSublingualContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_10 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='alxoid'
                                            onChange={() => setAlxoid(!alxoid)}
                                            checked={alxoid}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Alxoid</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.alxoidContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_11 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='oraltek'
                                            onChange={() => setOraltek(!oraltek)}
                                            checked={oraltek}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Oraltek</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.oraltekContador }</div>
                                </div>
                            </div>
                            </>}
                            {(categoriaEstatusInmunoterapias) && <>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_12 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='inmunoterapiaDeInicio'
                                            onChange={() => setInmunoterapiaDeInicio(!inmunoterapiaDeInicio)}
                                            checked={inmunoterapiaDeInicio}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Inmunoterapias</div>
                                        <div>de inicio</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.inmunoterapiaDeInicioContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_13 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='inmunoterapiasTerminadas'
                                            onChange={() => setInmunoterapiasTerminadas(!inmunoterapiasTerminadas)}
                                            checked={inmunoterapiasTerminadas}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Inmunoterapias</div>
                                        <div>terminadas</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.inmunoterapiasTerminadasContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_14 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='inmunoterapiasInconclusas'
                                            onChange={() => setInmunoterapiasInconclusas(!inmunoterapiasInconclusas)}
                                            checked={inmunoterapiasInconclusas}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Inmunoterapias</div>
                                        <div>inconclusas</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.inmunoterapiasInconclusasContador }</div>
                                </div>
                            </div>
                            </>}
                            {(categoriaMediosContacto) && <>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_15 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoInstagram'
                                            onChange={() => setMedioContactoInstagram(!medioContactoInstagram)}
                                            checked={medioContactoInstagram}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Instagram</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.instagramContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_16 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoFacebook'
                                            onChange={() => setMedioContactoFacebook(!medioContactoFacebook)}
                                            checked={medioContactoFacebook}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Facebook</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.facebookContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_17 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoTiktok'
                                            onChange={() => setMedioContactoTiktok(!medioContactoTiktok)}
                                            checked={medioContactoTiktok}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Tiktok</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.tiktokContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_18 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoPaginaWeb'
                                            onChange={() => setMedioContactoPaginaWeb(!medioContactoPaginaWeb)}
                                            checked={medioContactoPaginaWeb}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Página web</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.paginaWebContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_19 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoReferenciaOtroDoctor'
                                            onChange={() => setMedioContactoReferenciaOtroDoctor(!medioContactoReferenciaOtroDoctor)}
                                            checked={medioContactoReferenciaOtroDoctor}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Referencia de</div>
                                        <div>otro doctor</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.referenciaOtroDoctorContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_20 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoReferenciaFamiliar'
                                            onChange={() => setMedioContactoReferenciaFamiliar(!medioContactoReferenciaFamiliar)}
                                            checked={medioContactoReferenciaFamiliar}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Referencia de</div>
                                        <div>familiar</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.referenciaFamiliarContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_21 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoReferenciaAmistad'
                                            onChange={() => setMedioContactoReferenciaAmistad(!medioContactoReferenciaAmistad)}
                                            checked={medioContactoReferenciaAmistad}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Referencia de</div>
                                        <div>amistad</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.referenciaAmistadContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_22 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoCentroMedicoHospital'
                                            onChange={() => setMedioContactoCentroMedicoHospital(!medioContactoCentroMedicoHospital)}
                                            checked={medioContactoCentroMedicoHospital}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Centro</div>
                                        <div>médico/hospital</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.centroMedicoHospitalContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_23 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoOtro'
                                            onChange={() => setMedioContactoOtro(!medioContactoOtro)}
                                            checked={medioContactoOtro}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>Otro</div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.otroContador }</div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                                <div className={styles.card} style={{ backgroundColor: colors.CHART_COLOR_24 }}>
                                    <div className={styles.cardCheckbox}>
                                        <CheckboxInput
                                            name='medioContactoNoEspecificado'
                                            onChange={() => setMedioContactoNoEspecificado(!medioContactoNoEspecificado)}
                                            checked={medioContactoNoEspecificado}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div>No</div>
                                        <div>especificado</div>
                                    </div>
                                    <div className={"text-center " + styles.cardNumber}>{ data.data.contadores.noEspecificadoContador }</div>
                                </div>
                            </div>
                            </>}
                        </div>
                        <div className="row">
                            <div className="col">
                                {(isLoading || isFetching)
                                ? <Loader />
                                : <>
                                    {(isError)
                                        ? <Error />
                                        : <>
                                            <div className='d-flex justify-content-center'>
                                                <ResponsiveContainer width="100%" height={400}>
                                                    <LineChart data={dataAux} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis />
                                                        <Tooltip />
                                                        <Legend />
                                                        {(categoriaConsultas) && <>
                                                        {(consultasTotales) && <Line type="monotone" dataKey="Consultas totales" stroke={colors.CHART_COLOR_1} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_1, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(consultasPrimeraVez) && <Line type="monotone" dataKey="Consultas primera vez" stroke={colors.CHART_COLOR_2} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_2, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(consultasSubsecuentes) && <Line type="monotone" dataKey="Consultas subsecuentes" stroke={colors.CHART_COLOR_3} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_3, strokeWidth: 6 }} animationDuration={500} />}
                                                        </>}
                                                        {(categoriaPruebasAlergia) && <>
                                                        {(pruebasDeAlergia) && <Line type="monotone" dataKey="Pruebas de alergia" stroke={colors.CHART_COLOR_4} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_4, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(pruebasDeAlergiaPositivas) && <Line type="monotone" dataKey="Pruebas de alergia positivas" stroke={colors.CHART_COLOR_5} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_5, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(pruebasDeAlergiaNegativas) && <Line type="monotone" dataKey="Pruebas de alergia negativas" stroke={colors.CHART_COLOR_6} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_6, strokeWidth: 6 }} animationDuration={500} />}
                                                        </>}
                                                        {(categoriaTipoInmunoterapias) && <>
                                                        {(inmunoterapias) && <Line type="monotone" dataKey="Inmunoterapias" stroke={colors.CHART_COLOR_7} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_7, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(inmunoterapiaSubcutanea) && <Line type="monotone" dataKey="Inmunoterapia subcutánea" stroke={colors.CHART_COLOR_8} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_8, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(inmunoterapiaSublingual) && <Line type="monotone" dataKey="Inmunoterapia sublingual" stroke={colors.CHART_COLOR_9} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_9, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(alxoid) && <Line type="monotone" dataKey="Alxoid" stroke={colors.CHART_COLOR_10} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_10, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(oraltek) && <Line type="monotone" dataKey="Oraltek" stroke={colors.CHART_COLOR_11} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_11, strokeWidth: 6 }} animationDuration={500} />}
                                                        </>}
                                                        {(categoriaEstatusInmunoterapias) && <>
                                                        {(inmunoterapiaDeInicio) && <Line type="monotone" dataKey="Inmunoterapia de inicio" stroke={colors.CHART_COLOR_12} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_12, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(inmunoterapiasTerminadas) && <Line type="monotone" dataKey="Inmunoterapias terminadas" stroke={colors.CHART_COLOR_13} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_13, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(inmunoterapiasInconclusas) && <Line type="monotone" dataKey="Inmunoterapias inconclusas" stroke={colors.CHART_COLOR_14} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_14, strokeWidth: 6 }} animationDuration={500} />}
                                                        </>}
                                                        {(categoriaMediosContacto) && <>
                                                        {(medioContactoInstagram) && <Line type="monotone" dataKey="Instagram" stroke={colors.CHART_COLOR_15} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_15, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoFacebook) && <Line type="monotone" dataKey="Facebook" stroke={colors.CHART_COLOR_16} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_16, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoTiktok) && <Line type="monotone" dataKey="Tiktok" stroke={colors.CHART_COLOR_17} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_17, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoPaginaWeb) && <Line type="monotone" dataKey="Pagina web" stroke={colors.CHART_COLOR_18} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_18, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoReferenciaOtroDoctor) && <Line type="monotone" dataKey="Referencia otro doctor" stroke={colors.CHART_COLOR_19} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_19, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoReferenciaFamiliar) && <Line type="monotone" dataKey="Referencia familiar" stroke={colors.CHART_COLOR_20} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_20, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoReferenciaAmistad) && <Line type="monotone" dataKey="Referencia amistad" stroke={colors.CHART_COLOR_21} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_21, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoCentroMedicoHospital) && <Line type="monotone" dataKey="Centro médico/hospital" stroke={colors.CHART_COLOR_22} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_22, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoOtro) && <Line type="monotone" dataKey="Otro" stroke={colors.CHART_COLOR_23} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_23, strokeWidth: 6 }} animationDuration={500} />}
                                                        {(medioContactoNoEspecificado) && <Line type="monotone" dataKey="No especificado" stroke={colors.CHART_COLOR_24} strokeWidth={3} dot={{ stroke: colors.CHART_COLOR_24, strokeWidth: 6 }} animationDuration={500} />}
                                                        </>}
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            </div>
                                        </>
                                    }
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : <div className='mt-3'>
        <Forbidden />
    </div>
}
